import { render, staticRenderFns } from "./SelectInteraction.vue?vue&type=template&id=2b3ae165"
import script from "./SelectInteraction.vue?vue&type=script&lang=js"
export * from "./SelectInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports